import { Component } from '@angular/core';

@Component({
	selector: 'cdx-svg-definitions',
	templateUrl: './svg-definitions.component.html',
	standalone: true,
})
export class SvgDefinitionsComponent { }
